module.exports = __webpack_public_path__ + "static/media/rapunfriends.31d819c0.jpeg";